import $ from 'jquery';
import PubSub from 'Utils/pub-sub';
import BreakpointDispatcher from 'Utils/breakpoint-dispatcher';
import SmoothScroll from 'Utils/smoothScroll';

export default class ScrollSlider {

  constructor(el) {
    this.el = el;
    this.sliderItem = $('.js-scroll-slider_item');
    this.sliderPanes = $('.js-scroll-slider_pane');

    this.imgUrls = this.getImagesUrl();
    this.lastScrollPos = 0;
    this.currentPaneIndex = 0;
    this.isFading = false;
    this.NUM_OF_IMAGES = this.imgUrls.length - 1;
    this.START_POSITION = 0;

    this.createSliderDots(this.sliderPanes.length);
    this.sliderDots = $('.js-scroll-slider_dot');

    this.handleScroll = this.handleScrollOffer;

    this.init();
  }

  init() {
    let self = this;

    BreakpointDispatcher.start();

    PubSub.subscribe('resize', function () {
      if ($(window).width() < 768) return;

      self.imagesCoords = self.buildImgCoords(self.imgUrls);
      self.setInitialPosition(false);
    });

    PubSub.subscribe('resize:mobile', function () {
      self.unBindScrollEvent();
    });

    PubSub.subscribe('resize:desktop', function () {
      self.imagesCoords = self.buildImgCoords(self.imgUrls);
      self.setInitialPosition(true);
      self.handleEvents();
    });

    if (BreakpointDispatcher.getState() === BreakpointDispatcher.breakpoint.DESKTOP) {
      setTimeout(function () {
        self.imagesCoords = self.buildImgCoords(self.imgUrls);
        self.setInitialPosition(true);
        self.handleEvents();
      }, 300);
    }
  }

  createSliderDots(numOfDots) {
    var dotHTML = '';

    for (let i = 0; i < numOfDots; i++) {
      if (i === 0) {
        dotHTML += '<li class="js-scroll-slider_dot is-active"></li>';
      } else {
        dotHTML += '<li class="js-scroll-slider_dot"></li>';
      }
    }

    $('.js-scroll-slider_dots').html(dotHTML);
  }

  getImagesUrl() {
    return [].slice.call($('.js-scroll-slider_image'))
            .map(img => img.getAttribute('data-src'));
  }

  setInitialPosition(hasToChangePane) {
    this.START_POSITION = this.imagesCoords[0].start;

    let currentPos = $(window).scrollTop() + this.START_POSITION,
        imagesCoords = this.imagesCoords,
        lastIndex = this.currentPaneIndex;

    for (var i = 0; i < imagesCoords.length; i++) {
      if (currentPos > imagesCoords[i].start &&
          currentPos < imagesCoords[i].end) {

        if (i === 0) return;

        this.currentPaneIndex = i;
        this.updateActiveDot(lastIndex, i);
        this.updateSliderPosition();

        return hasToChangePane &&
              this.changePane();
      }
    }
  }

  unBindScrollEvent() {
    $(document).off('scroll', this.handleScrollCallBack);
  }

  handleEvents() {
    let self = this;

    this.handleScrollCallBack = handleScrollCallBack;

    $(document).scroll(handleScrollCallBack);

    this.sliderDots.click((e) => this.handleDotsClick(e));

    function handleScrollCallBack(scrollEvent) {
      self.handleScroll(scrollEvent);
    }
  }

  handleDotsClick(e) {
    let offset = this.imagesCoords[this.sliderDots.index(e.target)].start;

    SmoothScroll.scrollTo(offset);
  }

  handleScrollOffer() {
    let currentPos = $(window).scrollTop() + this.START_POSITION;

    switch (this.isScrollDown()) {
      case true:
        if (this.hasToGetNextPane(currentPos)) {
          this.updateActiveDot(
              this.currentPaneIndex,
              this.incrementIndex()
          );

          this.currentPaneIndex = this.incrementIndex();
          this.changePane();
          this.updateSliderPosition();
        }
      break;

      case false:
        if (this.hasToGetPrevPane(currentPos)) {
          this.updateActiveDot(
            this.currentPaneIndex,
            this.decrementIndex()
          );
          this.currentPaneIndex = this.decrementIndex();
          this.changePane();
          this.updateSliderPosition();
        }
      break;
    }
  }

  changePane() {
    this.applyTransition(this.updateBackgroundImage);
  }

  updateSliderPosition() {
    let topPos = this.getCurrentPane().start - 150;

    this.el.css(
      'transform',
      'translate3d(-50%,' + topPos + 'px, 0)' 
    );
  }

  applyTransition(callback) {
    let self = this;

    if (this.isFading) return;
    this.isFading = true;

    this.sliderItem.on('transitionend', function transitionEndCb () {
      self.isFading = false;
      self.sliderItem.off('transitionend', transitionEndCb);

      callback.call(self);
      self.sliderItem.addClass('is-active');
    });

    this.sliderItem.removeClass('is-active');
  }

  updateBackgroundImage() {
    this.sliderItem.attr(
      'src',
      this.getCurrentPane().imgUrl
    );
  }

  updateActiveDot(oldIndex, newIndex) {
    if (oldIndex === newIndex) return;

    this.sliderDots.eq(newIndex).addClass('is-active');
    this.sliderDots.eq(oldIndex).removeClass('is-active');
  }

  hasToGetNextPane(currentPos) {
    return this.currentPaneIndex < this.NUM_OF_IMAGES && currentPos > this.getCurrentPane().end;
  }

  hasToGetPrevPane(currentPos) {
    return this.currentPaneIndex !== 0 &&
           currentPos < this.getPrevPane().end;
  }

  getCurrentPane() {
    return this.imagesCoords[this.currentPaneIndex];
  }

  getPrevPane() {
    return this.imagesCoords[Math.max(0,this.currentPaneIndex-1)];
  }

  buildImgCoords(urls) {
    return [].map.call(this.sliderPanes, (pane, i) => ({
      start: $(pane).offset().top,
      end: $(pane).offset().top + $(pane).outerHeight(),
      imgUrl: urls[i]
    }));
  }

  isScrollDown() {
    let isScrollingDown = $(window).scrollTop() > this.lastScrollPos ?
      true :
      false;

    this.lastScrollPos = $(window).scrollTop();

    return isScrollingDown;
  }

  incrementIndex() {
    return Math.min(
        this.NUM_OF_IMAGES, 
        this.currentPaneIndex+1
      );
  }

  decrementIndex() {
    return Math.max(0, this.currentPaneIndex-1);
  }

  getWindowTopPosition() {
    return $(window).scrollTop();
  }
}


// WEBPACK FOOTER //
// ./src/components/scroll-slider/scroll-slider.js